<template>
  <div class="mb-4">
    <label for="input-file">
      <v-img
        contain
        v-if="previewUrl && mediaFormat === 'PHOTO'"
        class="image-preview dashed-border"
        max-height="500px"
        :src="previewUrl"
      >
      </v-img>
      <iframe
          v-if="previewUrl && mediaFormat === 'VIDEO'"
          loading="lazy"
          sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation allow-presentation"
          class="embed-responsive-item"
          allowfullscreen
          :src="previewUrl"
          height="250px"
          width="100%"
          frameborder="0">
      </iframe>
      <div class="upload-area dashed-border" v-if="!previewUrl">
        <v-icon>mdi-camera</v-icon>
      </div>
      <v-file-input
          id="input-file"
          name="file"
          hide-input
          accept="image/jpeg, image/png, image/jpg, video/mp4"
          prepend-icon=""
          outlined
          dense
          ref="input-file"
          v-model="file"
          @change="previewImage"
      ></v-file-input>
    </label>

    <v-row no-gutters v-if="previewUrl">
      <v-spacer/>
      <v-col>
        <v-btn @click="clearInput" class="my-2" text small>Remover imagem</v-btn>
      </v-col>
      <v-spacer/>
    </v-row>

    <v-snackbar
        v-model="snackbar.show"
        timeout="3000"
        :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'UploadImage',
  props: {
    maxSize: Number,
    url: String
  },
  data: () => ({
    file: null,
    previewUrl: null,
    mediaFormat: 'PHOTO',
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
  }),
  methods: {
    previewImage(file) {
      this.$emit('change', file)
      if (!file) {
        this.previewUrl = null
        this.mediaFormat = 'PHOTO'
        return
      }
      if (this.maxSize && file.size > this.maxSize) {
        this.showNotification(`O tamanho da imagem deve ser menor que ${this.maxSize} bytes!`, 'red darken-2')
      }
      if(file.type === 'video/mp4') {
        this.mediaFormat = 'VIDEO'
      }
      this.previewUrl = URL.createObjectURL(file)
      this.$emit('url-change', this.previewUrl)
      this.$emit('get-media-format', this.mediaFormat)
    },
    clearInput() {
      this.previewUrl = null
      this.mediaFormat = 'PHOTO'
      this.file = null
      this.$emit('url-change', this.previewUrl)
    },
    showNotification: function(message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
  },
  created() {
    this.previewUrl = this.url

    if(this.url) {
      let contains = this.url.includes('mp4')
      if (contains) {
        this.mediaFormat = 'VIDEO'
      }
    }
  },
  watch: {
    url: function(url) {
      this.previewUrl = url
    }
  }
}
</script>

<style scoped>
.dashed-border {
  border: none;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23E0E0E0FF' stroke-width='4' stroke-dasharray='3%2c 9' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 12px;
}

.upload-area {
  width: 100%;
  height: 120px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-area:hover {
  background-color: #F0F0F0;
}

.image-preview {
  cursor: pointer;
  width: 100%;
  min-height: 120px;
  max-height: 300px;
  object-fit: cover;
  padding: 5px;
}
</style>